import * as React from "react";

const TransposeGrid = (props: any) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g fillRule="evenodd">
      <path
        d="M5.295 7h-.589C3.766 7 3 7.725 3 8.615v10.77C3 20.275 3.766 21 4.706 21h.589C6.235 21 7 20.275 7 19.385V8.615C7 7.725 6.235 7 5.295 7zM19.384 3H8.614C7.725 3 7 3.765 7 4.706v.588C7 6.234 7.725 7 8.615 7h10.77C20.274 7 21 6.235 21 5.294v-.588C21 3.766 20.275 3 19.384 3zm.613 2.294c0 .357-.274.647-.612.647H8.615c-.338 0-.612-.29-.612-.647v-.588c0-.357.274-.647.612-.647h10.77c.338 0 .612.29.612.647v.588zM15.223 16.755h-2.031v.727c0 .34-.363.545-.645.37l-2.25-1.404c-.396-.248-.396-.88 0-1.126l2.25-1.405a.424.424 0 0 1 .645.37v.727h2.031c.825 0 1.161-.336 1.161-1.16v-3.395c.018-.417 1.324-.78 1.742 0v3.394c0 1.79-1.112 2.902-2.903 2.902z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default TransposeGrid;

